export function dataInJs() {
    var document = [
        {
            name: '一、 接口简介',
            content: '<div>电子印章对接提供云签方式</div>' +
                '<div class="flex"> ' +
                    '<div class="punctuation"></div> ' +
                    '<span>所谓云签：我司提供基于云技术的电子印章的签章和验证的在线服务，脱离签章介质，印章信息由加密机统一存储，通过权限分配及访问限制，实现印章的签署和验证功能，满足移动端签、验需求。</span>' +
                '</div>'

        },
        {
            name: '二、 接口安全',
            content: null,
            children: [
                {
                    name: '2.1 前置网关（IP 绑定）',
                    content:
                        '<div>前置网关，位于签章 API 服务和第三方服务之间，所有的第三方服务请求，都通过它来访问签章 API 服务，它可以拦截所有的第三方服务请求，提供 IP 绑定和 Token 验证 2 种防护方式。可以有效的为签章 API 服务提供安全防护和授权认证。</div>' +
                        '<div style="height: 230px;width: 534px" class="pic2-1" ></div>' +
                        '<div class="flex"> ' +
                            '<div class="punctuation"></div> ' +
                            '<span><span class="fw">第三方 IP 绑定。</span>第三方服务请求时，根据请求来源的 IP 进行过滤，仅允许已绑定 IP 的第三方服务访问签章 API 服务。其他的请求 IP，则拒绝。</span>' +
                        '</div>' +
                        '<div class="flex"> ' +
                            '<div class="punctuation"></div> ' +
                            '<span><span class="fw">访问 Token 验证。</span>第三方服务请求时，根据请求的 header 带有的 token，进行 token 验证，验证失败，则不允许访问签章服务；反之，则允许。</span>' +
                        '</div>'
                    ,
                },
                {
                    name: '2.2 接口防重放',
                    content:
                        '<div class="flex fz18 fw"><div class="punctuation"></div>基于 timestamp 和 nonceStr 的方案</div>' +
                        '<span>每次接口请求，都需要拼接 timestamp 参数和 nonceStr 参数。 签章 API 服务会获取请求中的这 2 个参数，先进行 timestamp 规则验证，若正常，再进行 nonceStr 规则验证。2 个规则都正常，才认为是合法请求，否则，就认为是非法请求。</span>' +
                        '<div class="flex fz18 fw"><div class="punctuation"></div>Timestamp 规则</div>' +
                        '<span>第三方服务器当前时间戳，计算到秒。 一次正常的 HTTP 请求，从发出到服务器不会超过60s。每次第三方请求时，签章 API 服务会把 timestamp 参数与当前时间相比较，判断是否超过了 60 秒。若已超出，则认为是非法请求。</span>' +
                        '<div class="flex fz18 fw"><div class="punctuation"></div>nonceStr 规则</div>' +
                        '<span>16 位长度的随机字符串，每次接口请求，签章 API 服务会校验签章服务器上是否已存在该随机字符串。若不存在，认为是合法请求，并将其缓存在签章服务器上。若已存在，则认为是非法请求。<span class="pointer fc-1890FF">（计算方法，可参考附录中的参考代码）</span></span>',
                },
                {
                    name: '2.3 接口防篡改',
                    content:
                        '<div>每次调用接口时，需要对接口中参与请求的数据进行签名。并将签名计算后的字符串放在请求的 Header 中传入，签章 API 服务会通过请求的 Header 中的 X-Gsign-Signature 参数来获取签名值，然后通过计算签名来验证请求数据是否被篡改。</div>' +
                        '<div class="flex fz18 fw mt20 mb20">步骤一：计算 Content-MD5</div>' +
                        '<div>1.  把接口请求 body 中的所有参数键值（file 类型除外），按照字母表进行顺序排序。</div>' +
                        '<div>2.  对排好序的参数进行拼接，如：key1=value1&key2=value2……</div>' +
                        '<div>3.  对拼接好的参数字符串，进行 MD5 运算，从而得到 MD5 的 32 位 Hex 字符串。</div>' +
                        '<div>4.  把得到的 MD5 字符串，附加到接口请求的 header 中的 Content-MD5 上。</div>' +
                        '<div class="flex fz18 fw mt20 mb20">步骤二：计算签名字符串</div>' +
                        '<div>1. 按<span class="fc-red">指定顺序</span>拼接待签字符串，全部为必选参数。</div>' +
                        '<table style="border-collapse: collapse;">' +
                            '<tr style="border-bottom: 1px solid black">' +
                            '<th>参数名</th><th>拼接顺序</th><th>说明</th>' +
                            '</tr><tr>' +
                            '<td>X-Gsign-App-Id</td><td>1</td><td>签章服务分配的应用 ID</td>' +
                            '</tr><tr>' +
                            '<td>X-Gsign-Cipher</td><td>2</td><td>密文加密算法，默认 SM4，支持 SM4，AES</td>' +
                            '</tr><tr>' +
                            '<td>Content-MD5</td><td>3</td><td>步骤一计算得到的 MD5 的 32 位 Hex 字符串</td>' +
                            '</tr><tr>' +
                            '<td>RequestURI</td><td>4</td><td>接口请求的 URI，不含域名。\n' + '例如：/api/v3/eseal/person/sign/points</td>' +
                            '</tr>' +
                        '</table>' +
                        '<div>待签字符串，只需要拼接参数值，不需要参数名，参数值之间使用英文冒号隔开。</div>' +
                        '<div>例 如 ： String signString = X-Gsign-App-Id + ":" + X-Gsign-Cipher + ":" +Content-MD5 + ":" +RequestURI</div>' +
                        '<div class="mt20">2. 使用签章API 服务分配的应用密钥（appSecret）对拼接好的待签字符串，采用HmacSHA256算法进行签名运算，从而得到签名字符串（Base64 安全编码）。<span class="pointer fc-1890FF">（计算方法，可参考附录中的参考代码）</span>' +
                        '<div class="mt20">3. 把得到的签名字符串，附加到接口请求的 header 中的 X-Gsign-Signature 上。</div>'
                },
                {
                    name: '2.4 cipherData 密文参数',
                    content:
                        '<div>1. 按照 cipherData 明文的 JSON 格式，拼接好 JSON 字符串。如：\n' +
                        '{"applyIdCard":"350781196403070024","applySigns":[{"idCard":"350781196403070024","s\n' +
                        'ealPin":"3070024","center":0,"x":45,"y":45,"page":1}]}</div>' +
                        '<div>2. 采用你指定的加密算法，对 JSON 字符串进行加密，再对加密后的内容，进行 base64 转码。<span class="pointer fc-1890FF">（计算方法，可参考附录中的参考代码）</span></div>'
                },
            ]
        },
        {
            name: '三、 对接接口',
            content: null,
            children: [
                {
                    name: '3.1 云签章接口',
                    content:
                        '<div>云签章，是指对文档签章时，需要上传待签文档到远端签章服务器上，签章完成后，需要通过下载地址，把签章完成的文档下载到您的服务器。</div>'
                    ,
                    children: [
                        {
                            name: '3.1.1 坐标签章接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>通过坐标定位方式，自动对 PDF/OFD 文档加盖电子印章</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/sign/coords</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST（form-data）</div>' +
                                '<div class="fw mt10 mb10">请求参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>请求数据签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>待签章文件</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyIdCard":"350781196403070024","fileMD5":" 809eca6b6ad821afab807a80e622b818","applySigns":[{"sealCode":"21020300016510","signCode":"350781196403070024","signImg":"8e5bbb25744f4ee7aab0be93996d1bb8==","signRole":"50","signPin":"50781","approveIdCard":"350781196403070024","x":45,"y":45,"page":1}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyIdCard</td><td>是</td><td>string</td><td>申请文档签章人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">fileMD5</td><td>是</td><td>string</td><td>待签章文件内容的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applySigns</td><td>是</td><td>Array</td><td>签章信息</td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealCode</td><td>否</td><td>string</td><td>电子印章编码signCode 和 signRole 为空时，必填</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signCode</td><td>否</td><td>string</td><td>签章编码，sealCode 为空时，必填<br />签章角色为 50 时，身份证号码；其他，企业社会统一信用代码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signRole</td><td>否</td><td>String</td><td>签章角色，sealCode 为空时，必填<span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td>signImg</td><td>否</td><td>String</td><td>个人签名图 png 格式，base64 <br />编码signRole 为 50 时，该字段有效</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signPin</td><td>是</td><td>String</td><td>签章授权人的签章密码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>approveIdCard</td><td>是</td><td>String</td><td>签章授权人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>x</td><td>是</td><td>float</td><td>签章位置左上角 X 坐标点，单位 px</td>' +
                                '</tr><tr>' +
                                '<td></td><td>y</td><td>是</td><td>float</td><td>签章位置左上角 Y 坐标点，单位 px</td>' +
                                '</tr><tr>' +
                                '<td></td><td>page</td><td>是</td><td>int</td><td>签章页码</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"docId":"8e5bbb25744f4ee7aab0be93996d1bb8","docName":"xxxx.pdf","downUrl":"http://xxx/api/v2/eseal/signed/down/8e5bbb25744f4ee7aab0be93996d1bb8/keywords.pdf"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td >code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td >data</td><td>object</td><td>操作结果数据</td>' +
                                '</tr><tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回 data 参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >docId</td><td>string</td><td>签章后文档的 ID</td>' +
                                '</tr><tr>' +
                                '<td >docName</td><td>int</td><td>签章后文档的名称</td>' +
                                '</tr><tr>' +
                                '<td >downUrl</td><td>object</td><td>签章后文档的下载地址，有效期 5 分钟</td>' +
                                '</tr><tr>' +
                                '</table>' +
                                ''
                            ,
                        },
                        {
                            name: '3.1.2 骑缝签章接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>根据设定的参数，自动对 PDF/OFD 文档加盖骑缝电子印章</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/sign/seams</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">请求参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>请求数据签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>待签章文件</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyIdCard":"350781196403070024","fileMD5":" 809eca6b6ad821afab807a80e622b818","applySigns":[{"sealCode":"21020300016510","signCode":"91210204341167191F","signRole":"01","signPin":"50781","approveIdCard":"350781196403070024","pageRangeBegin":1,"pageRangeEnd":9,"percentage":20,"position":"1/5","direction":"R"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyIdCard</td><td>是</td><td>string</td><td>申请人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">fileMD5</td><td>是</td><td>string</td><td>待签章文件内容的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applySigns</td><td>是</td><td>Array</td><td>签章信息</td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealCode</td><td>否</td><td>string</td><td>电子印章编码signCode 和 signRole 为空时，必填</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signCode</td><td>否</td><td>string</td><td>签章编码，sealCode 为空时，必填<br />签章角色为 50 时，身份证号码；其他，企业社会统一信用代码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signRole</td><td>否</td><td>String</td><td>签章角色，sealCode 为空时，必填<span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td>signImg</td><td>否</td><td>String</td><td>个人签名图 png 格式，base64 <br />编码signRole 为 50 时，该字段有效</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signPin</td><td>是</td><td>String</td><td>签章授权人的签章密码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>approveIdCard</td><td>是</td><td>String</td><td>签章授权人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>pageRangeBegin</td><td>否</td><td>int</td><td>骑缝章起始页码，默认 1</td>' +
                                '</tr><tr>' +
                                '<td></td><td>pageRangeEnd</td><td>否</td><td>int</td><td>骑缝章结束页码，默认-1<br />-1 代表最后一页</td>' +
                                '</tr><tr>' +
                                '<td></td><td>percentage</td><td>否</td><td>int</td><td>印章首页百分比（5-95），默认 20</td>' +
                                '</tr><tr>' +
                                '<td></td><td>position</td><td>否</td><td>string</td><td>骑缝位置，默认：1/5（可选值：1/5；2/5；3/5；4/5）</td>' +
                                '</tr><tr>' +
                                '<td></td><td>direction</td><td>否</td><td>string</td><td>骑缝方向，默认：R（R：右骑缝；D：下骑缝；L：左骑缝；T：上骑缝）</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"docId":"8e5bbb25744f4ee7aab0be93996d1bb8","docName":"xxxx.pdf","downUrl":"http://xxx/api/v2/eseal/signed/down/8e5bbb25744f4ee7aab0be93996d1bb8/keywords.pdf"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td >code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td >data</td><td>object</td><td>操作结果数据</td>' +
                                '</tr><tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回 data 参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >docId</td><td>string</td><td>签章后文档的 ID</td>' +
                                '</tr><tr>' +
                                '<td >docName</td><td>int</td><td>签章后文档的名称</td>' +
                                '</tr><tr>' +
                                '<td >downUrl</td><td>object</td><td>签章后文档的下载地址，有效期 5 分钟</td>' +
                                '</tr><tr>' +
                                '</table>' +
                                ''
                            ,
                        },
                        {
                            name: '3.1.3 关键字签章接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>通过指定关键字，自动对 PDF/OFD 文档中的关键字所在位置加盖电子印章</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/sign/keywords</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">请求参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>请求数据签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>待签章文件</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyIdCard":"350781196403070024","fileMD5":" 809eca6b6ad821afab807a80e622b818","applySigns":[{"sealCode":"21020300016510","signCode":"350781196403070024","signRole":"50","signPin":"50781","approveIdCard":"350781196403070024","shiftX":0,"shiftY":0,"pageNumber":0,"keywordIndex":0,"keyword":"签章"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyIdCard</td><td>是</td><td>string</td><td>申请人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">fileMD5</td><td>是</td><td>string</td><td>待签章文件内容的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applySigns</td><td>是</td><td>Array</td><td>签章信息</td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealCode</td><td>否</td><td>string</td><td>电子印章编码signCode 和 signRole 为空时，必填</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signCode</td><td>否</td><td>string</td><td>签章编码，sealCode 为空时，必填<br />签章角色为 50 时，身份证号码；其他，企业社会统一信用代码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signRole</td><td>否</td><td>String</td><td>签章角色，sealCode 为空时，必填<span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td>signImg</td><td>否</td><td>String</td><td>个人签名图 png 格式，base64 <br />编码signRole 为 50 时，该字段有效</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signPin</td><td>是</td><td>String</td><td>签章授权人的签章密码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>approveIdCard</td><td>是</td><td>String</td><td>签章授权人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>keyword</td><td>是</td><td>String</td><td>关键字</td>' +
                                '</tr><tr>' +
                                '<td></td><td>shiftX</td><td>否</td><td>float</td><td>签章 X 坐标点偏移量，正数向右，负数向左</td>' +
                                '</tr><tr>' +
                                '<td></td><td>shiftY</td><td>否</td><td>float</td><td>签章 Y 坐标点偏移量，正数向下，负数向上</td>' +
                                '</tr><tr>' +
                                '<td></td><td>pageNumber</td><td>否</td><td>array</td><td>关键字页码，默认全文查找</td>' +
                                '</tr><tr>' +
                                '<td></td><td>keywordIndex</td><td>否</td><td>int</td><td>关键字索引，0 是全部，-1 是最后一个</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"docId":"8e5bbb25744f4ee7aab0be93996d1bb8","docName":"keywords.pdf","downUrl":"http://xxxx/api/v3/eseal/signed/down/8e5bbb25744f4ee7aab0be93996d1bb8/keywords.pdf"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td >code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td >data</td><td>object</td><td>操作结果数据</td>' +
                                '</tr><tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回 data 参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >docId</td><td>string</td><td>签章后文档的 ID</td>' +
                                '</tr><tr>' +
                                '<td >docName</td><td>int</td><td>签章后文档的名称</td>' +
                                '</tr><tr>' +
                                '<td >downUrl</td><td>object</td><td>签章后文档的下载地址，有效期 5 分钟</td>' +
                                '</tr><tr>' +
                                '</table>' +
                                ''
                            ,
                        },
                    ]
                },
                {
                    name: '3.2 分发签章接口',
                    children: [
                        {
                            name: '3.2.1 创建分发签章接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>上传待签文档，创建分发签章</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/dispatch/sign/create</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">请求参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>请求数据签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>File</td><td>是</td><td>File[]</td><td>Body</td><td>签章文件列表</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"signTitle":"xxxxxxx","signNo":"2xxxxxxxxxxxxx","applyIdCard":"1111111111111","applyName":"王僧","signMode":"1","liveFace":"1","liveWrite":"0","notifyUrl":"https://xxxx","signDocs":[{"docMD5":"12312321321","docName":"sdfdsfs.pdf"}],"signerList":[{"signerId":"12312321321","signerName":"xxxxxx"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">signTitle</td><td>是</td><td>string</td><td>签章标题</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyIdCard</td><td>是</td><td>string</td><td>签章申请人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyName</td><td>是</td><td>string</td><td>签章申请人姓名</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signMode</td><td>是</td><td>String</td><td>签署模式 0 授权签 1 自由签 2 定位签</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">liveFace</td><td>否</td><td>String</td><td>活体识别：0 不开启 1 开启</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">liveWrite</td><td>否</td><td>String</td><td>强制手绘签名：0 可用已有签名 1 强制手绘</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">notifyUrl</td><td>否</td><td>String</td><td>异步通知地址</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signNo</td><td>否</td><td>String</td><td>签章编号（不能大于32个字符）</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signDocs</td><td>是</td><td>Array</td><td>签章文档信息</td>' +
                                '</tr><tr>' +
                                '<td></td><td>docMD5</td><td>是</td><td>string</td><td>待签文档的MD5值</td>' +
                                '</tr><tr>' +
                                '<td></td><td>docName</td><td>是</td><td>string</td><td>待签文档的名称</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signerList</td><td>否</td><td>Array</td><td>签章人列表</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signerId</td><td>是</td><td>string</td><td>签章者证件号（企业信用代码也可）</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signerName</td><td>是</td><td>string</td><td>签章者名称（企业名称）</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"docList":[{"docName":"接受证据清单-1.pdf","docId":256722117648385,"docType":"application/pdf","docMD5":"7ba0442d37b9519acb389b341311d6d4"}],"signId":256722117648384,"signToken":"QZ_eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9WqvuPEA"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td >code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td >data</td><td>object</td><td>操作结果数据</td>' +
                                '</tr><tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回 data 参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">signId</td><td>string</td><td>签章ID</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signToken</td><td>string</td><td>签章Token，有效期5分钟，<br />可生成二维码，官方小程序可扫码识别</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">docList</td><td>Array</td><td>待签文档列表</td>' +
                                '</tr><tr>' +
                                '<td></td><td>docId</td><td>string</td><td>待签文档ID</td>' +
                                '</tr><tr>' +
                                '<td></td><td>docType</td><td>string</td><td>待签文档类型</td>' +
                                '</tr><tr>' +
                                '<td></td><td>docMD5</td><td>string</td><td>待签文档MD5值</td>' +
                                '</tr><tr>' +
                                '<td></td><td>docName</td><td>string</td><td>待签文档名称</td>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">回调参数密文示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"cipherData":"xxxxxxxxxxxxxxxxxxxxxxxxx","nonceStr":"vj6S5UQWTIK7lEq8","timestamp":"1732082850","signature":"xxxxxxxxxxxxxxxxxx"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">回调参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >cipherData</td><td>string</td><td>签章信息密文，使用应用密钥进行SM4加密</td>' +
                                '</tr><tr>' +
                                '<td >nonceStr</td><td>string</td><td>随机码</td>' +
                                '</tr><tr>' +
                                '<td >timestamp</td><td>string</td><td>时间戳</td>' +
                                '</tr><tr>' +
                                '<td >signature</td><td>string</td><td>回调参数签名，签名规则：<br /> 1）签名字符串组合，StringsigString = cipherData + ":" + nonceStr + ":"timestamp <br /> 2）使用签章API服务分配的应用密钥（appSecret）对拼接好的待签字符串，采用HmacSHA256算法进行签名运算，从而得到签名字符串（Base64安全编码）。<span class="pointer fc-1890FF">（计算方法，可参考附录中的参考代码）</span></td>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">回调cipherData参数明文示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"signId":318388954968064,"signNo":"318388954968064","signState":"2","signerId":"1427301xxxxxx16","signerName":"张灵军","livePhoto":"/9j/4AAQSkZJRgABAQAAAQAB=","docId":318388954968065,"docName":"oa.ofd","docType":"application/ofd","signSeals":[{"sealName":"广烁测试(电子印章)","signCode":"91210204341167191F","signRole":"05","sealCode":"21020401000101"},{"sealName":"张灵军(手写签名)","signCode":"14273xxxxxxxxxxxxx16","signRole":"50","sealCode":"142730xxxxx072","sealPic":"xxxxxxx=="}],"authSeals":[{"sealName":"广烁测试(电子印章)","signCode":"91210204341167191F","signRole":"05","sealCode":"21020401000101","preSignId":"xxxx","sealPic":"xxxxxxx==","width":"42","height":"42"},{"sealName":"张灵军(手写签名)","signCode":"14273xxxxxxxxxxxxx16","signRole":"50","sealCode":"142730xxxxx072","preSignId":"xxxx","sealPic":"xxxxxxx==","width":"42","height":"42"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">回调参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>类型</th><th>必选</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">signId</td><td>string</td><td>是</td><td>签章ID</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signNo</td><td>string</td><td>是</td><td>签章编码，<br /> 和用户创建传入一致，若创建时没传入，则和 signId 一致</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signState</td><td>string</td><td>是</td><td>签章状态：-1 拒签 1 授权 2 签章 3 人身核验</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signerId</td><td>string</td><td>是</td><td>签章人证件号</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signerName</td><td>string</td><td>是</td><td>签章人姓名</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">livePhoto</td><td>string</td><td>否</td><td>人身核验通过的现场人像（base64 编码）<br /> signState 为 3 时，存在</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">docId</td><td>string</td><td>否</td><td>文档 ID <br /> signState 为-1 时，不存在</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">docName</td><td>string</td><td>否</td><td>文档名称 <br /> signState 为-1 时，不存在</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">docType</td><td>string</td><td>否</td><td>文档名称 <br /> signState 为-1 时，不存在</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signSeals</td><td>Array</td><td>否</td><td>文档名称 <br /> signState 为 2 时，存在</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signCode</td><td>string</td><td>是</td><td>签章编码 <br /> 企业印章为企业统一信用代码 <br /> 个人签名为身份证号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signRole</td><td>string</td><td>是</td><td>签章类型，<span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealCode</td><td>string</td><td>是</td><td>电子印章编码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealName</td><td>string</td><td>是</td><td>电子印章名称</td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealPic</td><td>string</td><td>是</td><td>如果是现写的手写签名则存在，其他情况不存在</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">authSeals</td><td>Array</td><td>否</td><td>授权的电子印章列表 <br /> signState 为 1 时，存在</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signCode</td><td>string</td><td>是</td><td>签章编码 <br /> 企业印章为企业统一信用代码 <br /> 个人签名为身份证号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>signRole</td><td>string</td><td>是</td><td>签章类型，<span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealCode</td><td>string</td><td>是</td><td>电子印章编码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealName</td><td>string</td><td>是</td><td>电子印章名称</td>' +
                                '</tr><tr>' +
                                '<td></td><td>preSignId</td><td>string</td><td>是</td><td>电子印章签章授权码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>sealPic</td><td>string</td><td>是</td><td>电子印章图片，base64 编码</td>' +
                                '</tr><tr>' +
                                '<td></td><td>width</td><td>Int</td><td>是</td><td>电子印章宽度 单位 mm</td>' +
                                '</tr><tr>' +
                                '<td></td><td>height</td><td>Int</td><td>是</td><td>电子印章高度 单位 mm</td>' +
                                '</table>' +
                                ''
                            ,
                        },
                        {
                            name: '3.2.2 对签章文档设定签章信息接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>上对创建的分发签章，设定签章信息，指定签章人</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/dispatch/doc/sign/apply</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">请求参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>待签章文件</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyIdCard":"142730198208031216","docId":254954906370049,"applySigns":[{"signInfo":[{"pageRangeEnd":-1,"percentage":20,"position":"1/5","pageRangeBegin":1,"direction":"R"}],"signName":"辽宁广烁科技有限公司","approveIdCard":"142730198208031216","signCode":"91210204341167191F","signRole":"01","signMethod":"seams"},{"signPin":"123456","signInfo":[{"x":122,"y":122,"page":1}],"signName":"辽宁广烁科技有限公司","approveIdCard":"142730198208031216","signCode":"91210204341167191F","signRole":"01","signMethod":"coords"},{"signInfo":[{"keyword":"保管人"}],"signName":"辽宁广烁科技有限公司","approveIdCard":"142730198208031216","signCode":"91210204341167191F","signRole":"05","signMethod":"keywords"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="3">参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="3">docId</td><td>是</td><td>string</td><td>待签文档 ID</td>' +
                                '</tr><tr>' +
                                '<td colspan="3">applyIdCard</td><td>是</td><td>string</td><td>申请人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td colspan="3">applySigns</td><td>否</td><td>Array</td><td>签章信息 <br /> docPolicy为1时，不可为空</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signCode</td><td>否</td><td>string</td><td>签章编码，sealCode为空时，必填 <br />签章角色为50时，身份证号码；其他，企业社会统一信用代码</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signRole</td><td>否</td><td>string</td><td>签章角色，sealCode为空时，必填<br /><span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">sealCode</td><td>否</td><td>string</td><td>印章编码<br />signCode和signRole为空时，必填</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signMethod</td><td>否</td><td>string</td><td>签署方法<br />coords 坐标签章   keywords 关键字签章   seams 骑缝签章</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">approveIdCard</td><td>是</td><td>string</td><td>签章参与者标识，<br />身份证号码或企业统一信用代码</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signInfo</td><td>否</td><td>array</td><td>签章设定</td>' +
                                '</tr><tr>' +
                                '<td></td><td rowspan="3">坐标签章</td><td>x</td><td>是</td><td>float</td><td>签章X坐标点</td>' +
                                '</tr><tr>' +
                                '<td></td><td>y</td><td>是</td><td>float</td><td>签章Y坐标点</td>' +
                                '</tr><tr>' +
                                '<td></td><td>page</td><td>是</td><td>int</td><td>签章页码</td>' +
                                '</tr><tr>' +
                                '<td></td><td rowspan="5">关键字签章</td><td>keyword</td><td>是</td><td>string</td><td>关键字</td>' +
                                '</tr><tr>' +
                                '<td></td><td>shiftX</td><td>否</td><td>float</td><td>签章X坐标点偏移量，正数向右，负数向左</td>' +
                                '</tr><tr>' +
                                '<td></td><td>shiftY</td><td>否</td><td>float</td><td>签章Y坐标点偏移量，正数向下，负数向上</td>' +
                                '</tr><tr>' +
                                '<td></td><td>pageNumber</td><td>否</td><td>array</td><td>关键字页码，默认全文查找</td>' +
                                '</tr><tr>' +
                                '<td></td><td>keywordIndex</td><td>否</td><td>int</td><td>关键字索引，0是全部，-1是最后一个</td>' +
                                '</tr><tr>' +
                                '<td></td><td rowspan="5">骑缝签章</td><td>pageRangeBegin</td><td>否</td><td>int</td><td>骑缝章起始页码，默认1</td>' +
                                '</tr><tr>' +
                                '<td></td><td>pageRangeEnd</td><td>否</td><td>int</td><td>骑缝章结束页码，默认-1 <br /> -1代表最后一页</td>' +
                                '</tr><tr>' +
                                '<td></td><td>percentage</td><td>否</td><td>int</td><td>印章首页百分比（5-95），默认20</td>' +
                                '</tr><tr>' +
                                '<td></td><td>position</td><td>否</td><td>string</td><td>骑缝位置，默认：1/5 <br />（可选值：1/5；2/5；3/5；4/5）</td>' +
                                '</tr><tr>' +
                                '<td></td><td>direction</td><td>否</td><td>string</td><td>骑缝方向，默认：R <br />（R：右骑缝；D：下骑缝；L：左骑缝；T：上骑缝）</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":[{"estimatedSize":20934,"height":42,"picType":"PNG8","preSignId":"Zju4VJ","sealCode":"21020200000068F","sealPic":"iVBORw0KGgoAAAANSUhEUgAAAMYAAADGCAmCC","signCode":"91210204341167191F","signRole":"01","width":42},{"estimatedSize":24496,"height":20,"picType":"PNG8","preSignId":"KBaTbG","sealCode":"21020401000101","sealPic":"iVBORw0KGgoAAAANSUhEUgAAAdgAAAHYCAYAAADu2fmZAAAAAX==","signCode":"91210204341167191F","signRole":"05","width":20}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>Int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>Array</td><td>若为授权签章（signMode=0）<br /> 返回有使用权限的印章列表</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回 data 参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>sealCode</td><td>string</td><td>电子印章编码</td>' +
                                '</tr><tr>' +
                                '<td>signCode</td><td>string</td><td>签章编码</td>' +
                                '</tr><tr>' +
                                '<td>signRole</td><td>string</td><td>签章角色</td>' +
                                '</tr><tr>' +
                                '<td>preSignId</td><td>string</td><td>签章授权码</td>' +
                                '</tr><tr>' +
                                '<td>sealPic</td><td>string</td><td>电子印章图片base64编码</td>' +
                                '</tr><tr>' +
                                '<td>picType</td><td>string</td><td>电子印章图片类型</td>' +
                                '</tr><tr>' +
                                '<td>width</td><td>Int</td><td>电子印章宽度，单位mm</td>' +
                                '</tr><tr>' +
                                '<td>height</td><td>Int</td><td>电子印章高度，单位mm</td>' +
                                '</tr><tr>' +
                                '<td>estimatedSize</td><td>Int</td><td>电子签章预计大小</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.2.3对待签文档进行云签署接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>对签章上传的文档进行远程云签署接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/dispatch/doc/sign/done</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">请求参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>待签章文件</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyIdCard":"142730198208031216","docId":254954906370049,"applySigns":[{"signInfo":[{"pageRangeEnd":-1,"percentage":20,"position":"1/5","pageRangeBegin":1,"direction":"R"}],"preSignId":"xxxxxx","sealCode":"21020401000101","signCode":"91210204341167191F","signRole":"01","signMethod":"seams"},{"signPin":"123456","signInfo":[{"x":122,"y":122,"page":1}],"approveIdCard":"142730198208031216","signCode":"91210204341167191F","signRole":"01","signMethod":"coords"},{"signInfo":[{"keyword":"保管人"}],"preSignId":"xxxxxx","sealCode":"21020401000101","signCode":"91210204341167191F","signRole":"05","signMethod":"keywords"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="3">参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="3">docId</td><td>是</td><td>string</td><td>待签文档 ID</td>' +
                                '</tr><tr>' +
                                '<td colspan="3">applyIdCard</td><td>是</td><td>string</td><td>申请人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td colspan="3">applySigns</td><td>否</td><td>Array</td><td>签章信息 <br /> docPolicy为1时，不可为空</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signCode</td><td>否</td><td>string</td><td>签章编码，sealCode为空时，必填 <br />签章角色为50时，身份证号码；其他，企业社会统一信用代码</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signRole</td><td>否</td><td>string</td><td>签章角色，sealCode为空时，必填<br /><span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">preSignId</td><td>否</td><td>string</td><td>签章授权码</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">sealCode</td><td>否</td><td>string</td><td>印章编码<br />signCode和signRole为空时，必填</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">approveIdCard</td><td>否</td><td>string</td><td>签章授权人</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signPin</td><td>否</td><td>string</td><td>签章授权密码，approveIdCard不为空时，必填</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signMethod</td><td>否</td><td>string</td><td>签署方法，<br /> coords 坐标签章 keywords 关键字签章 seams 骑缝签章</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">approveIdCard</td><td>是</td><td>string</td><td>签章人身份证号码（签章企业信用代码）</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="2">signInfo</td><td>否</td><td>array</td><td>签章设定</td>' +
                                '</tr><tr>' +
                                '<td></td><td rowspan="3">坐标签章</td><td>x</td><td>是</td><td>float</td><td>签章X坐标点</td>' +
                                '</tr><tr>' +
                                '<td></td><td>y</td><td>是</td><td>float</td><td>签章Y坐标点</td>' +
                                '</tr><tr>' +
                                '<td></td><td>page</td><td>是</td><td>int</td><td>签章页码</td>' +
                                '</tr><tr>' +
                                '<td></td><td rowspan="5">关键字签章</td><td>keyword</td><td>是</td><td>string</td><td>关键字</td>' +
                                '</tr><tr>' +
                                '<td></td><td>shiftX</td><td>否</td><td>float</td><td>签章X坐标点偏移量，正数向右，负数向左</td>' +
                                '</tr><tr>' +
                                '<td></td><td>shiftY</td><td>否</td><td>float</td><td>签章Y坐标点偏移量，正数向下，负数向上</td>' +
                                '</tr><tr>' +
                                '<td></td><td>pageNumber</td><td>否</td><td>array</td><td>关键字页码，默认全文查找</td>' +
                                '</tr><tr>' +
                                '<td></td><td>keywordIndex</td><td>否</td><td>int</td><td>关键字索引，0是全部，-1是最后一个</td>' +
                                '</tr><tr>' +
                                '<td></td><td rowspan="5">骑缝签章</td><td>pageRangeBegin</td><td>否</td><td>int</td><td>骑缝章起始页码，默认1</td>' +
                                '</tr><tr>' +
                                '<td></td><td>pageRangeEnd</td><td>否</td><td>int</td><td>骑缝章结束页码，默认-1 <br /> -1代表最后一页</td>' +
                                '</tr><tr>' +
                                '<td></td><td>percentage</td><td>否</td><td>int</td><td>印章首页百分比（5-95），默认20</td>' +
                                '</tr><tr>' +
                                '<td></td><td>position</td><td>否</td><td>string</td><td>骑缝位置，默认：1/5 <br />（可选值：1/5；2/5；3/5；4/5）</td>' +
                                '</tr><tr>' +
                                '<td></td><td>direction</td><td>否</td><td>string</td><td>骑缝方向，默认：R <br />（R：右骑缝；D：下骑缝；L：左骑缝；T：上骑缝）</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"docId":"8e5bbb25744f4ee7aab0be93996d1bb8","docName":"keywords.pdf","docType":"application/pdf","downUrl":"http://xxxx /8e5bbb25744f4ee7aab0be93996d1bb8/keywords.pdf"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>Int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>Array</td><td>操作结果数据</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回 data 参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>docId</td><td>string</td><td>签章文档ID</td>' +
                                '</tr><tr>' +
                                '<td>docName</td><td>string</td><td>签章文档名称</td>' +
                                '</tr><tr>' +
                                '<td>docType</td><td>string</td><td>签章文档类型</td>' +
                                '</tr><tr>' +
                                '<td>downUrl</td><td>string</td><td>签章文档下载地址</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.2.4查询分发签章信息接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>获取签章信息的接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/dispatch/sign/info</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>待签章文件</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"signId":"xxds","signNo":"xxxxxxxxxx"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>signId</td><td>否</td><td>Long</td><td>签章ID <br />  signNo为空时，必填</td>' +
                                '</tr><tr>' +
                                '<td>signNo</td><td>否</td><td>string</td><td>签章编码 <br />  signId为空时，必填</td>' +
                                '</tr><tr>' +
                                '<td>applyIdCard</td><td>是</td><td>string</td><td>申请人身份证号码</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"signId":299845239820290,"signTitle":"接受证据清单-1.pdf","signMode":"1","status":"0","createBy":"印章接入测试","applyIdCard":"xxxxxxsssssss","createTime":"2024-09-30 10:02:23","signerList":[{"signerId":"142730xxxx16","signType":"2","signState":"0","signerName":"张说"},{"signerId":"xxxxxx","signerName":"xxxxxx","signType":"2","signState":"1","signTime":"2024-09-30 10:02:23","optId":"xxxxxx","optName":"xxxxx","remark":"不想签"}],"docList":[{"docId":299845239820291,"docName":"接受证据清单-1.pdf","docType":"application/pdf","createTime":"2024-09-30 10:02:23","signerList":[{"signerId":"162730xxxx1ss16","signerName":"张说","signType":"1","sealList":[{"sealName":"张说(手写签名)","signTime":"2024-09-30 10:02:27","sealType":"50","sealCode":"162730H00000072"}]}]}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>string</td><td>电子签章数据</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="4">参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="4">signId</td><td>int</td><td>签章ID</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">signTitle</td><td>string</td><td>签章的标题</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">signMode</td><td>string</td><td>签章模式 0授权签章 1自由签章 2定位签章</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">liveFace</td><td>string</td><td>活体识别：0不开启 1开启</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">liveWrite</td><td>string</td><td>强制现写签名：0可用已有签名1强制现写</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">status</td><td>string</td><td>签章状态 0状态 1锁定</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">createBy</td><td>string</td><td>签章创建人</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">applyIdCard</td><td>string</td><td>签章创建人身份证信息</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">createTime</td><td>string</td><td>签章创建时间</td>' +
                                '</tr><tr>' +
                                '<td colspan="4">signerList</td><td>Array</td><td>签章参与者列表</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">signerId</td><td>string</td><td>签章者证件号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">signerName</td><td>string</td><td>签章者姓名</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">signType</td><td>string</td><td>签章类型 1签章创建者 2签章参与者</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">signState</td><td>string</td><td>签章状态 0正常 1拒绝 2签过</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">signTime</td><td>string</td><td>操作日期</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">optId</td><td>string</td><td>经办人证件号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">optName</td><td>string</td><td>经办人者姓名</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">remark</td><td>string</td><td>备注，signState为1时，拒绝原因</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="4">docList</td><td>Array</td><td>待签文档列表</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">docId</td><td>string</td><td>待签文档ID</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">docType</td><td>string</td><td>待签文档类型</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">docName</td><td>string</td><td>待签文档名称</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">createTime</td><td>string</td><td>待签文档创建时间</td>' +
                                '</tr><tr>' +
                                '<td></td><td colspan="3">signerList</td><td>Array</td><td>签章者列表</td>' +
                                '</tr><tr>' +
                                '<td></td><td></td><td colspan="2">signerId</td><td>string</td><td>签章者证件号</td>' +
                                '</tr><tr>' +
                                '<td></td><td></td><td colspan="2">signerName</td><td>string</td><td>签章者姓名</td>' +
                                '</tr><tr>' +
                                '<td></td><td></td><td colspan="2">signType</td><td>string</td><td>签章类型 1签署 2授权</td>' +
                                '</tr><tr>' +
                                '<td></td><td></td><td colspan="2">sealList</td><td>Array</td><td>印章列表</td>' +
                                '</tr><tr>' +
                                '<td></td><td></td><td></td><td>sealCode</td><td>string</td><td>印章编码</td>' +
                                '</tr><tr>' +
                                '<td></td><td></td><td></td><td>sealName</td><td>string</td><td>印章名称</td>' +
                                '</tr><tr>' +
                                '<td></td><td></td><td></td><td>sealType</td><td>string</td><td>印章类型</td>' +
                                '</tr><tr>' +
                                '<td></td><td></td><td></td><td>signTime</td><td>string</td><td>签署时间</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.2.5创建Web签章插件接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>创建Web端签章插件接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/signPad/create</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"title":"测试一下","signer":"王颖","signerId":"2549549060989","liveFace":"1","liveWrite":"1","notifyUrl":"https://xxx"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>title</td><td>是</td><td>string</td><td>签章标题</td>' +
                                '</tr><tr>' +
                                '<td>signer</td><td>是</td><td>string</td><td>创建人</td>' +
                                '</tr><tr>' +
                                '<td>signerId</td><td>是</td><td>string</td><td>创建人证件号</td>' +
                                '</tr><tr>' +
                                '<td>liveFace</td><td>否</td><td>string</td><td>活体识别（<span class="fc-red">移动端无效</span>）：0不开启 1开启</td>' +
                                '</tr><tr>' +
                                '<td>liveWrite</td><td>否</td><td>string</td><td>强制手绘签名：0可用已有签名 1强制手绘</td>' +
                                '</tr><tr>' +
                                '<td>notifyUrl</td><td>是</td><td>string</td><td>异步回调地址</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"padUrl":"http://e.lngsyz.com/#/task/verify/xxxxxxx","signNo":"1471778908235776"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td >code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td >data</td><td>object</td><td>Web 端签章插件信息</td>' +
                                '</tr><tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回 data 参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >padUrl</td><td>string</td><td>Web端签章插件地址</td>' +
                                '</tr><tr>' +
                                '<td >signNo</td><td>string</td><td>签章ID</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">回调参数密文示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"cipherData":"xxxxxxxxxxxxxxxxxxxxxxxxx","nonceStr":"vj6S5UQWTIK7lEq8","timestamp":"1732082850","signature":"xxxxxxxxxxxxxxxxxx"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">回调参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th >参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td >cipherData</td><td>string</td><td>签章信息密文，使用应用密钥进行SM4加密</td>' +
                                '</tr><tr>' +
                                '<td >nonceStr</td><td>string</td><td>随机码</td>' +
                                '</tr><tr>' +
                                '<td >timestamp</td><td>string</td><td>时间戳</td>' +
                                '</tr><tr>' +
                                '<td >signature</td><td>string</td><td>回调参数签名，签名规则：<br/> 1）签名字符串组合，StringsigString=cipherData+":"+nonceStr+":"+timestamp <br/> 2）使用签章API服务分配的应用密钥（appSecret）对拼接好的待签字符串，采用HmacSHA256算法进行签名运算，从而得到签名字符串（Base64安全编码）。<span class="pointer fc-1890FF">（计算方法，可参考附录中的参考代码）</span></td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">回调cipherData参数明文示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"signId":318388954968064,"signNo":"318388954968064","signState":"2","docId":318388954968065,"docName":"oa.ofd","docType":"application/ofd","signerId":"1427301xxxxxx16","signerName":"张灵军","signSeals":[{"sealName":"广烁测试(电子印章)","signCode":"91210204341167191F","signRole":"05","sealCode":"21020401000101"},{"sealName":"张灵军(手写签名)","signCode":"14273xxxxxxxxxxxxx16","signRole":"50","sealCode":"142730xxxxx072"}],"authSeals":[{"sealName":"广烁测试(电子印章)","signCode":"91210204341167191F","signRole":"05","sealCode":"21020401000101","preSignId":"xxxx","sealPic":"xxxxxxx==","width":"42","height":"42"},{"sealName":"张灵军(手写签名)","signCode":"14273xxxxxxxxxxxxx16","signRole":"50","sealCode":"142730xxxxx072","preSignId":"xxxx","sealPic":"xxxxxxx==","width":"42","height":"42"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">回调参数说明</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>类型</th><th>必选</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">signId</td><td>string</td><td>是</td><td>签章 ID</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signNo</td><td>string</td><td>是</td><td>签章编码， <br />  和用户创建传入一致，若创建时没传入，则和signId一致</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signState</td><td>string</td><td>是</td><td>签章状态：-1拒签1授权2签章</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signerId</td><td>string</td><td>是</td><td>签章人证件号</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signerName</td><td>string</td><td>是</td><td>签章人姓名</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">docId</td><td>string</td><td>否</td><td>文档ID <br /> signState为-1时，不存在</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">docName</td><td>string</td><td>否</td><td>文档名称 <br /> signState为-1时，不存在</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">docType</td><td>string</td><td>否</td><td>文档类型 <br /> signState为-1时，不存在</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">signSeals</td><td>Array</td><td>否</td><td>签署的电子印章列表 <br /> signState为2时，存在</td>' +
                                '</tr><tr>' +
                                '<td></td><td >signCode</td><td>string</td><td>是</td><td>签章编码， <br /> 企业印章为企业统一信用代码  个人签名为身份证号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td >signRole</td><td>string</td><td>是</td><td>签章类型，<span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td >sealCode</td><td>string</td><td>是</td><td>电子印章编码</td>' +
                                '</tr><tr>' +
                                '<td></td><td >sealName</td><td>string</td><td>是</td><td>电子印章名称</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">authSeals</td><td>Array</td><td>否</td><td>授权的电子印章列表 <br /> signState为1时，存在</td>' +
                                '</tr><tr>' +
                                '<td></td><td >signCode</td><td>string</td><td>是</td><td>签章编码， <br /> 企业印章为企业统一信用代码  个人签名为身份证号码</td>' +
                                '</tr><tr>' +
                                '<td></td><td >signRole</td><td>string</td><td>是</td><td>签章类型，<span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td></td><td >sealCode</td><td>string</td><td>是</td><td>电子印章编码</td>' +
                                '</tr><tr>' +
                                '<td></td><td >sealName</td><td>string</td><td>是</td><td>电子印章名称</td>' +
                                '</tr><tr>' +
                                '<td></td><td >preSignId</td><td>string</td><td>是</td><td>电子印章签章授权码</td>' +
                                '</tr><tr>' +
                                '<td></td><td >sealPic</td><td>string</td><td>是</td><td>电子印章图片，base64编码</td>' +
                                '</tr><tr>' +
                                '<td></td><td >width</td><td>Int</td><td>是</td><td>电子印章宽度 单位 mm</td>' +
                                '</tr><tr>' +
                                '<td></td><td >height</td><td>Int</td><td>是</td><td>电子印章高度 单位 mm</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.2.6创建签章web浏览地址接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>获取签章的Web浏览地址接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/signPad/signView/create</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"signId":"331385765871616","signNo":"331385765871616","applyName":"王洋","applyId":"142730xxxxx1839"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>signId</td><td>否</td><td>Long</td><td>签章ID，ID和编码二选一</td>' +
                                '</tr><tr>' +
                                '<td>signNo</td><td>否</td><td>string</td><td>签章编码，ID和编码二选一</td>' +
                                '</tr><tr>' +
                                '<td>applyName</td><td>是</td><td>string</td><td>签章人</td>' +
                                '</tr><tr>' +
                                '<td>applyId</td><td>是</td><td>string</td><td>签章人证件号</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":"http://e.lngsyz.com/#/task/verify/xxxxxxx"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>string</td><td>签章Web端浏览地址</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.2.7撤销分发签章信息接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>撤销已创建的签章接口，将删除所有签章信息（含签章文档）</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/dispatch/sign/revoke</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST （form-data）</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"signId":"293013073653760","applyIdCard":"123xxxxxxxxxx24"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>signId</td><td>是</td><td>Long</td><td>签章ID</td>' +
                                '</tr><tr>' +
                                '<td>applyIdCard</td><td>是</td><td>string</td><td>申请人身份证号码和创建时一致</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr>' +
                                '</table>' +
                            ''
                        }
                    ]
                },
                {
                    name: '3.3 个人签名接口',
                    children: [
                        {
                            name: '3.3.1 申请个人签名接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>通过姓名，身份证号，签名图来申请个人签名接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/psn/seal/apply</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>String</td><td>Body</td><td>签名图片</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"name":"王二小","idCard":"350781196403070024","fileMD5":"809eca6b6ad821afab807a80e622b818"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>name</td><td>是</td><td>string</td><td>申请人姓名</td>' +
                                '</tr><tr>' +
                                '<td>idCard</td><td>是</td><td>string</td><td>申请人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td>fileMD5</td><td>是</td><td>string</td><td>签名图片的MD5值</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"sealName":"王伟","sealCode":"350781196403070024","expireTime ":"2023-07-19 15:34:47","height":"20"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>印章信息</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>sealName</td><td>string</td><td>签名名称</td>' +
                                '</tr><tr>' +
                                '<td>sealCode</td><td>int</td><td>签名编码</td>' +
                                '</tr><tr>' +
                                '<td>expireTime</td><td>string</td><td>签名失效日期</td>' +
                                '</tr><tr>' +
                                '<td>height</td><td>int</td><td>签名图片高度单位：mm</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.3.2查询个人签名接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>查询已存在的个人签名接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/psn/seal/info</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"idCard":"350781196403070024"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>idCard</td><td>是</td><td>string</td><td>身份证号码</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"sealName":"王伟","sealCode":"350781196403070024","sealImage":"iVBORw0KGgoAAAANSUhE==","expireTime ":"2023-07-19 15:34:47","height":"20"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；404：签名不存在500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>印章信息</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>sealName</td><td>string</td><td>签名名称</td>' +
                                '</tr><tr>' +
                                '<td>sealCode</td><td>string</td><td>签名编码</td>' +
                                '</tr><tr>' +
                                '<td>sealImage</td><td>string</td><td>签名图片数据base64格式</td>' +
                                '</tr><tr>' +
                                '<td>expireTime</td><td>string</td><td>签名失效日期</td>' +
                                '</tr><tr>' +
                                '<td>height</td><td>int</td><td>签名图片高度单位：mm</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.3.3查询是否已存在个人签名接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>查询是否已存在个人签名接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/psn/seal/exists</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"idCard":"350781196403070024"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>idCard</td><td>是</td><td>string</td><td>身份证号码</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":"Y"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>string</td><td>Y：存在 N：不存在</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.3.4创建采集签名图的手绘板接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>创建一个手绘签名板，来采集个人签名图片</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/handPad/identify/create</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"padNo":"350781196403070024","idCard":"14273019xxxx9087","userName":"刘三","withImage":"1","notifyUrl":"https://xxx.com","redirectUrl":"https://xxx.com"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>padNo</td><td>是</td><td>string</td><td>手绘板编号（不能大于32个字符）</td>' +
                                '</tr><tr>' +
                                '<td>idCard</td><td>是</td><td>string</td><td>用户身份证号码</td>' +
                                '</tr><tr>' +
                                '<td>userName</td><td>是</td><td>string</td><td>用户姓名</td>' +
                                '</tr><tr>' +
                                '<td>withImage</td><td>否</td><td>string</td><td>回调参数是否含图片：0不含 1含 <br />  不含图片时，采集的签名图仅供本次签章使用</td>' +
                                '</tr><tr>' +
                                '<td>notifyUrl</td><td>否</td><td>string</td><td>采集完成后，服务端回调地址</td>' +
                                '</tr><tr>' +
                                '<td>redirectUrl</td><td>否</td><td>string</td><td>采集完成后，页面跳转地址</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":"http://seal.lngsyz.com/#/handwriting?t=ilPITkMl"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>string</td><td>手绘签名板链接地址</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        }
                    ]
                },
                {
                    name: '3.4印章列表接口（需申请开通）',
                    children: [
                        {
                            name: '3.4.1获取我的电子印章列表接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>获取我有授权的电子印章列表接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/my/seal/list</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"idCard":"210211198506051247"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>idCard</td><td>是</td><td>string</td><td>身份证号码</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":[{"sealCode":"21020401000101","sealName":"广烁测试(电子印章)","sealHeight":42,"sealWidth":42,"sealThumb":"iVBORw0KGAAElFTkSuQmCC","sealType":"05","validEnd":"2025-09-24 23:25:25","validStart":"2024-09-24 23:25:25","deptCode":"91210204341167191F","deptName":"辽宁广烁科技有限公司","adminAuth":true,"createTime":"2024-09-24 23:25:25"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>印章信息</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>sealCode</td><td>string</td><td>印章编码</td>' +
                                '</tr><tr>' +
                                '<td>sealName</td><td>int</td><td>印章名称</td>' +
                                '</tr><tr>' +
                                '<td>sealHeight</td><td>int</td><td>印章图片高度单位：mm</td>' +
                                '</tr><tr>' +
                                '<td>sealWidth</td><td>int</td><td>印章图片宽度单位：mm</td>' +
                                '</tr><tr>' +
                                '<td>deptCode</td><td>string</td><td>印章所属者编码 <br /> sealType为50时，身份证号码 <br /> 其他，则为企业统一信用代码 </td>' +
                                '</tr><tr>' +
                                '<td>deptName</td><td>string</td><td>印章所属者名称 <br /> sealType为50时，用户姓名 <br /> 其他，则为企业名称 </td>' +
                                '</tr><tr>' +
                                '<td>createTime</td><td>string</td><td>印章创建时间 </td>' +
                                '</tr><tr>' +
                                '<td>orgCode</td><td>string</td><td>企业统一信用代码 </td>' +
                                '</tr><tr>' +
                                '<td>validStart</td><td>string</td><td>印章有效期始 </td>' +
                                '</tr><tr>' +
                                '<td>validEnd</td><td>string</td><td>印章有效期止 </td>' +
                                '</tr><tr>' +
                                '<td>sealType</td><td>string</td><td>印章类型 </td>' +
                                '</tr><tr>' +
                                '<td>sealThumb</td><td>string</td><td>印章图base64编码 </td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.4.2获取企业电子印章列表接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>获取已存在的企业印章接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/org/seal/list</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"orgCode":"91210204341167191F"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>orgCode</td><td>是</td><td>string</td><td>企业统一信用代码</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":[{"sealName":"广烁测试章","orgName":"辽宁广烁科技有限公司","createTime":"2023-04-28 15:03:03","orgCode":"91210204341167191F","validStart":"2023-04-28 15:05:15","validEnd":"2024-04-27 15:05:15","width":"42","sealImgThumbnail":"644b6fa60084222543f1592c","sealType":"99","sealCode":"21020200000065F","height":"42"}]}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>印章信息</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>sealCode</td><td>string</td><td>印章编码</td>' +
                                '</tr><tr>' +
                                '<td>sealName</td><td>int</td><td>印章名称</td>' +
                                '</tr><tr>' +
                                '<td>orgName</td><td>int</td><td>企业名称</td>' +
                                '</tr><tr>' +
                                '<td>createTime</td><td>int</td><td>印章创建时间</td>' +
                                '</tr><tr>' +
                                '<td>orgCode</td><td>int</td><td>企业统一信用代码</td>' +
                                '</tr><tr>' +
                                '<td>validStart</td><td>int</td><td>印章有效期始</td>' +
                                '</tr><tr>' +
                                '<td>validEnd</td><td>int</td><td>印章有效期止</td>' +
                                '</tr><tr>' +
                                '<td>height</td><td>int</td><td>印章图片高度单位：mm</td>' +
                                '</tr><tr>' +
                                '<td>width</td><td>int</td><td>印章图片宽度单位：mm</td>' +
                                '</tr><tr>' +
                                '<td>sealType</td><td>string</td><td>印章类型</td>' +
                                '</tr><tr>' +
                                '<td>sealImgThumbnail</td><td>string</td><td>印章图标识</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                    ]
                },
                {
                    name: '3.5签章文档接口',
                    children: [
                        {
                            name: '3.5.1下载签章文档接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>签章后的文档下载接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/doc/down</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyIdCard":"350781196403070024","docId":"8e5bbb25744f4ee7aab0be93996d1bb8"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>applyIdCard</td><td>是</td><td>string</td><td>申请人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td>docId</td><td>是</td><td>string</td><td>文档 ID</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":"http://localhost:8642/api/v3/eseal/signed/down/8e5bbb25744f4ee7aab0be93996d1bb8/keyw ords.pdf"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>签章后的文档下载地址，有效期 5 分钟</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.5.2验证签章文档接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>文档验章接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/verify</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST（form-data）</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>已签章文件</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"result":"true","fileName":"oa.sig.ofd","signedInfo":[{"sealTypeName":"其它类型章","propertyInfo":"oa.ofd","sealState":true,"ownerId":"91210204341167191F","ownerName":"辽宁广烁科技有限公司","dataHash":"DsgTT9EXsnabauvt763Oe8t1ZFx2mBTDHehHIP1Usx8=","eseal":{"createDate":"2024-08-01 10:58:00","esID":"21020401000101","id":"ES","name":"广烁测试(电子印章)","type":"99","validEnd":"2025-08-04 10:57:52","validStart":"2024-08-01 10:57:52","version":"V2","vid":"LNGSYZ"},"recordMsg":"已备案至辽宁省公安厅","signedDate":"2024-08-28 06:06:52","cert":{"issuer":"C=CN,O=AnXin CA,CN=AnXin SM2 CA","notAfter":"2025-08-04 10:57:52","notBefore":"2024-08-01 10:57:52","serialNumber":"6FCD4CC3C984B6E88CE1DD6312E6888B","sigAlgName":"SM3WITHSM2","subject":"C=CN,ST=辽宁省,L=大连市,O=91210204341167191F 辽宁广 烁科技有限公司,OU=LNGSYZ,CN=21020401000101","version":"V3"}}]}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>array</td><td>电子签章验证信息</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>result</td><td>string</td><td>验证结果 <br /> True:验证通过false：验证未通过500：验证失败 </td>' +
                                '</tr><tr>' +
                                '<td>fileName</td><td>string</td><td>文档名称</td>' +
                                '</tr><tr>' +
                                '<td>signedInfo</td><td>array</td><td>签署信息</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回signedInfo参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>signedDate</td><td>string</td><td>文档签署时间</td>' +
                                '</tr><tr>' +
                                '<td>cert</td><td>object</td><td>证书信息</td>' +
                                '</tr><tr>' +
                                '<td>eseal</td><td>object</td><td>印章信息</td>' +
                                '</tr><tr>' +
                                '<td>dataHash</td><td>string</td><td>签署时文档的HASH值</td>' +
                                '</tr><tr>' +
                                '<td>propertyInfo</td><td>string</td><td>签署时文档的属性信息</td>' +
                                '</tr><tr>' +
                                '<td>sealState</td><td>boolean</td><td>验签印章状态</td>' +
                                '</tr><tr>' +
                                '<td>sealTypeName</td><td>string</td><td>印章类型描述</td>' +
                                '</tr><tr>' +
                                '<td>ownerId</td><td>string</td><td>印章所有者证件号（<span class="fc-6abf47">非必选参数</span>）</td>' +
                                '</tr><tr>' +
                                '<td>ownerName</td><td>string</td><td>印章所有名称（<span class="fc-6abf47">非必选参数</span>）</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回eseal参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>esID</td><td>string</td><td>电子印章编码</td>' +
                                '</tr><tr>' +
                                '<td>id</td><td>string</td><td>电子印章头标识</td>' +
                                '</tr><tr>' +
                                '<td>version</td><td>string</td><td>电子印章版本号</td>' +
                                '</tr><tr>' +
                                '<td>vid</td><td>string</td><td>电子印章厂商标识</td>' +
                                '</tr><tr>' +
                                '<td>type</td><td>string</td><td>电子印章类型</td>' +
                                '</tr><tr>' +
                                '<td>name</td><td>string</td><td>电子印章名称</td>' +
                                '</tr><tr>' +
                                '<td>createDate</td><td>string</td><td>电子印章创建时间</td>' +
                                '</tr><tr>' +
                                '<td>validStart</td><td>string</td><td>电子印章有效起始时间</td>' +
                                '</tr><tr>' +
                                '<td>validEnd</td><td>string</td><td>电子印章有效截至时间</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回cert参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>version</td><td>string</td><td>数字证书版本号</td>' +
                                '</tr><tr>' +
                                '<td>serialNumber</td><td>string</td><td>数字证书序列号</td>' +
                                '</tr><tr>' +
                                '<td>sigAlgName</td><td>string</td><td>数字证书签名方法</td>' +
                                '</tr><tr>' +
                                '<td>issuer</td><td>string</td><td>数字证书提供者</td>' +
                                '</tr><tr>' +
                                '<td>notBefore</td><td>string</td><td>数字证书有效起始时间</td>' +
                                '</tr><tr>' +
                                '<td>notAfter</td><td>string</td><td>数字证书有效截至时间</td>' +
                                '</tr><tr>' +
                                '<td>subject</td><td>string</td><td>数字证书使用者信息</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },

                    ]
                },
                {
                    name: '3.6申请印章接口（需申请开通）',
                    children: [
                        {
                            name: '3.6.1申请制作企业印章接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>申请制作企业印章接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/org/seal/apply</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"orgName":"辽宁广烁科技有限公司","orgEnName":"","orgMinorityName":"","orgCode":"91210204341167191F","orgType":"1","orgRegionCode":"210202","legalName":"刘秀刚","legalPhone":"13588888874","legalId":"210211198502011452","operatorName":"刘秀刚 2","operatorPhone":"13588888874","operatorId":"210211198502011452","applyType":"01","physicalId":"210202000114254","sealWidth":"42","sealHeight":"42","notifyUrl":"http://xx.com/xxxx"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>orgName</td><td>是</td><td>string</td><td>企业名称</td>' +
                                '</tr><tr>' +
                                '<td>orgEnName</td><td>否</td><td>string</td><td>企业英文名称</td>' +
                                '</tr><tr>' +
                                '<td>orgMinorityName</td><td>否</td><td>string</td><td>企业少数民族名称</td>' +
                                '</tr><tr>' +
                                '<td>orgCode</td><td>是</td><td>string</td><td>企业社会统一信用代码</td>' +
                                '</tr><tr>' +
                                '<td>orgType</td><td>是</td><td>string</td><td>企业类型 <br /> 1：党政机关、人大、政协 2：企业单位 3：事业单位 4：社会团体 5：民营非企业单位 </td>' +
                                '</tr><tr>' +
                                '<td>orgRegionCode</td><td>是</td><td>string</td><td>企业所在行政区号代码</td>' +
                                '</tr><tr>' +
                                '<td>legalName</td><td>是</td><td>string</td><td>法人姓名</td>' +
                                '</tr><tr>' +
                                '<td>legalPhone</td><td>是</td><td>string</td><td>法人电话</td>' +
                                '</tr><tr>' +
                                '<td>legalId</td><td>是</td><td>string</td><td>法人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td>operatorName</td><td>是</td><td>string</td><td>经办人姓名</td>' +
                                '</tr><tr>' +
                                '<td>operatorPhone</td><td>是</td><td>string</td><td>经办人电话</td>' +
                                '</tr><tr>' +
                                '<td>operatorId</td><td>是</td><td>string</td><td>经办人身份证号码</td>' +
                                '</tr><tr>' +
                                '<td>applyType</td><td>是</td><td>string</td><td>申请印章类型，<span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td>sealWidth</td><td>是</td><td>int</td><td>实体印章的宽度（印记图的宽）单位mm</td>' +
                                '</tr><tr>' +
                                '<td>sealHeight</td><td>是</td><td>int</td><td>实体印章印记图的高度（印记图的高）单位mm</td>' +
                                '</tr><tr>' +
                                '<td>physicalId</td><td>是</td><td>string</td><td>实体印章编码</td>' +
                                '</tr><tr>' +
                                '<td>notifyUrl</td><td>否</td><td>string</td><td>异步通知地址，通知数据见返回示例</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0,"data":{"applyNo":"350781196403070024","applyStatus":"-1","applyMsg":"法人身份证反面照片模糊不清","applyTime ":"2023-07-19 15:34:47"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>印章信息</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyNo</td><td>string</td><td>申请编号</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyStatus</td><td>string</td><td>申请状态 <br /> 0：待资质上传, -1：申请驳回, 1：审核中, 2：制作中 3：制作完成 4：待支付 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyMsg</td><td>string</td><td>申请驳回描述,applyStatus为-1时，返回</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">amount</td><td>float</td><td>待支付金额，单位元applyStatus为4时，返回</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyTime</td><td>string</td><td>申请日期</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">sealInfo</td><td>Object</td><td>电子印章信息 <br /> applyStatus为3时，返回该值 </td>' +
                                '</tr><tr>' +
                                '<td></td> <td >sealCode</td><td>string</td><td>电子印章编码</td>' +
                                '</tr><tr>' +
                                '<td></td> <td >sealName</td><td>string</td><td>电子印章名称</td>' +
                                '</tr><tr>' +
                                '<td></td> <td >sealType</td><td>string</td><td>电子印章类型</td>' +
                                '</tr><tr>' +
                                '<td></td> <td >width</td><td>Int</td><td>电子印章宽度 单位 mm</td>' +
                                '</tr><tr>' +
                                '<td></td> <td >height</td><td>Int</td><td>电子印章高度 单位 mm</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.6.2上传印章申请的资质接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>上传申请印章制作的资质接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/apply/credential/upload</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST（form-data）</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyNo":"91210204341167191F","credentialType":"BUSINESS_LICENSE ","fileMD5":"809eca6b6ad821afab807a80e622b818"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>applyNo</td><td>是</td><td>string</td><td>申请编号</td>' +
                                '</tr><tr>' +
                                '<td>credentialType</td><td>是</td><td>string</td><td>资质类型 <br/> BUSINESSLICENSE 营业执照 <br/> LEGFRONTID 法人身份证正面 <br/> LEGBACKID 法人身份证反面 <br/> OPERFRONTID 经办人身份证正面 <br/> OPERBACKID 经办人身份证反面 <br/> OPERSCENE 经办人现场图（辽宁省外，其他省份上传法人现场图，建议都上传法人现场图） <br/> PHYSICALIMPRINT 印章印记图 <br/> ESEALMOULAGE 印章印模图（除辽宁省外，必传）</td>' +
                                '</tr><tr>' +
                                '<td>fileMD5</td><td>是</td><td>string</td><td>资质文件的MD5</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.6.3查询印章申请详情接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>查询印章申请信息接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/apply/query</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyNo":350781196403070024}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>applyNo</td><td>是</td><td>string</td><td>申请编号</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyType":"06","legalPhone":"1864xxxxx3500","orgName":"辽宁 xxxx 有限公司","physicalId":"210xxxxx05935","legalId":"21030xxxxxxxx1X","applyMsg":"制作完成","sealHeight":42,"operatorPhone":"1564xxxxx66","operatorName":"张丹","legalName":"赵毅未","orgType":"2","orgRegionCode":"210303","orgCode":"912103xxxxxxJQHB11","applyNo":"241928004xxxx458","applyTime":"2024-04-24 15:57:01","amount":"365.00","sealInfo":{"sealName":"辽宁 xxxx 有限公司-[电子印章]","sealType":"06","sealCode":"2103000xxxxx51"},"operatorId":"21038119xxxxx6045","applyStatus":"3","sealWidth":42}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>印章信息</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th colspan="2">参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyNo</td><td>string</td><td>申请编号</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyType</td><td>string</td><td>印章类型 <span class="pointer fc-1890FF">详见附录</span></td>' +
                                '</tr><tr>' +
                                '<td colspan="2">physicalId</td><td>string</td><td>实体印章编码</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">sealWidth</td><td>int</td><td>实体印章宽度单位 mm</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">sealHeight</td><td>int</td><td>实体印章高度单位 mm</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">orgCode</td><td>string</td><td>企业信用代码</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">orgName</td><td>string</td><td>企业名称</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">orgRegionCode</td><td>string</td><td>企业区域代码</td>' +
                                '</tr><tr>' +
                                '<td colspan="2">orgType</td><td>string</td><td>企业类型 <br /> 1：党政机关、人大、政协 2：企业单位 3：事业单位 4：社会团体 5：民营非企业单位 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyStatus</td><td>string</td><td>申请状态 <br /> 0：待资质上传, -1：申请驳回, 1：审核中, 2：制作中 3：制作完成 4：待支付 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyMsg</td><td>string</td><td>申请驳回描述,applyStatus为-1时，返回该值 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">amount</td><td>float</td><td>待支付金额，单位元applyStatus为4时，返回该值 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">legalId</td><td>string</td><td>法人身份证号码 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">legalName</td><td>string</td><td>法人姓名 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">legalPhone</td><td>string</td><td>法人手机号码 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">operatorId</td><td>string</td><td>经办人身份证号码 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">operatorName</td><td>string</td><td>经办人姓名 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">operatorPhone</td><td>string</td><td>经办人手机号码 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">applyTime</td><td>string</td><td>申请日期 </td>' +
                                '</tr><tr>' +
                                '<td colspan="2">sealInfo</td><td>Object</td><td>电子印章信息 <br /> pplyStatus为3时，返回该值 </td>' +
                                '</tr><tr>' +
                                '<td></td><td >sealCode</td><td>string</td><td>电子印章编码</td>' +
                                '</tr><tr>' +
                                '<td></td><td >sealName</td><td>string</td><td>电子印章名称</td>' +
                                '</tr><tr>' +
                                '<td></td><td >sealType</td><td>string</td><td>电子印章类型</td>' +
                                '</tr><tr>' +
                                '<td></td><td >width</td><td>Int</td><td>电子印章宽度 单位 mm</td>' +
                                '</tr><tr>' +
                                '<td></td><td >height</td><td>Int</td><td>电子印章高度 单位 mm</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.6.4撤销印章申请接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>撤销已提交的印章申请接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/apply/revoke</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyNo":91210204341167191}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>applyNo</td><td>是</td><td>string</td><td>申请编号</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.6.5申诉印章申请接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>申请印章被驳回时，可以进行申诉接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/apply/appeal</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyNo":91210204341167191,"appealMsg":"xxxxxxxx"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>applyNo</td><td>是</td><td>string</td><td>申请编号</td>' +
                                '</tr><tr>' +
                                '<td>appealMsg</td><td>是</td><td>string</td><td>申诉原因</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.6.6 印章申请支付接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>申请机构印章时，需要支付费用的接口</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/eseal/apply/pay</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"applyNo":91210204341167191,"payType":"wxpay"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>applyNo</td><td>是</td><td>string</td><td>申请编号</td>' +
                                '</tr><tr>' +
                                '<td>payType</td><td>是</td><td>string</td><td>支付类型，微信支付:wxpay 支付宝支付:alipay</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"msg":"success","code":0}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>string</td><td>支付二维码（base64编码）</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                    ]
                },
                {
                    name: '3.7身份证认证接口（需申请开通）',
                    children: [
                        {
                            name: '3.7.1人像姓名身份证三元素认证接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>提交姓名、身份证、人像图片，进行三元素认证</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/verification/three/identify</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST（form-data）</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>file</td><td>是</td><td>file</td><td>Body</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"name":"王峰","idCard":"210211198207031326","fileMD5":"809eca6b6ad821afab807a80e622b818"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>name</td><td>是</td><td>string</td><td>真实姓名</td>' +
                                '</tr><tr>' +
                                '<td>idCard</td><td>是</td><td>string</td><td>身份证号码</td>' +
                                '</tr><tr>' +
                                '<td>fileMD5</td><td>否</td><td>string</td><td>人像图片的MD5值，三元素认证时，必传</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"code":0,"msg":"操作成功","data":{" code":1," score":0}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>三元素认证结果</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>code</td><td>Int</td><td>0：认证成功 <br /> 1：认证失败 <br /> 2：不存在 <br /> 3：非本人认证 <br /> 4：认证信息不完整 <br /> 5：认证有风险 <br /> 9：系统异常 <br /> 500312、500216、500310：认证有风险 <br /> 500410：认证有风险-非人 <br /> 500412：认证有风险-照片不清晰 <br /> 500415：认证有风险-可能有多人 <br /> 500416：认证有风险-请重拍照片 <br /> 500417：认证有风险-疑似非活体</td>' +
                                '</tr><tr>' +
                                '<td>score</td><td>float</td><td>检测安全度，0-100之间，人脸比对时该值有参考意义</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.7.2创建人身活体核验接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>提交姓名、身份证，创建人身活体身份核验</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/verification/face/identify/create</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"name":"王峰","idCard":"210211198207031326","redirectUrl":"https://xxxx"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>name</td><td>是</td><td>string</td><td>真实姓名</td>' +
                                '</tr><tr>' +
                                '<td>idCard</td><td>是</td><td>string</td><td>身份证号码</td>' +
                                '</tr><tr>' +
                                '<td>redirectUrl</td><td>否</td><td>string</td><td>手机端完成核验后，跳转到指定地址 <br /> H5 端使用，PC 端不建议使用</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"code":0,"msg":"操作成功","data":{"checkId":"f8385d2699c178ce","url":"http://xxx/api/v1/plugin/face/verify/f8385d2699c178ce"}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td></td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>checkId</td><td>string</td><td>人身活体核验ID，用于查询核验结果</td>' +
                                '</tr><tr>' +
                                '<td>url</td><td>string</td><td>人身活体核验地址</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                        {
                            name: '3.7.3查询人身活体核验结果接口',
                            content:
                                '<div class="fw mb10">简要描述：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>提交人身活体核验ID，进行核验结果查询</div>' +
                                '<div class="fw mt10 mb10">请求 URL：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>http://xx.com/api/v3/verification/face/identify/query</div>' +
                                '<div class="fw mt10 mb10">请求方式：</div>' +
                                '<div class="flex"><div class="punctuation-sm"></div>POST</div>' +
                                '<div class="fw mt10 mb10">参数：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>位置</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-App-Id</td><td>是</td><td>string</td><td>Header</td><td>接口应用编号</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Cipher</td><td>否</td><td>string</td><td>Header</td><td>密文数据加密算法，不设置默认为 SM4 支持 SM4，AES</td>' +
                                '</tr><tr>' +
                                '<td>Content-MD5</td><td>是</td><td>string</td><td>Header</td><td>请求 body 参数的 MD5 值（32 位 Hex）</td>' +
                                '</tr><tr>' +
                                '<td>X-Gsign-Signature</td><td>是</td><td>string</td><td>Header</td><td>参数签名字符串</td>' +
                                '</tr><tr>' +
                                '<td>cipherData</td><td>是</td><td>String</td><td>Body</td><td>密文数据，明文为 JSON 格式</td>' +
                                '</tr><tr>' +
                                '<td>timestamp</td><td>是</td><td>String</td><td>Body</td><td>服务器当前时间戳（秒）</td>' +
                                '</tr><tr>' +
                                '<td>nonceStr</td><td>是</td><td>String</td><td>Body</td><td>随机字符串，长度要求 16 位。</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">cipherData 的 JSON 示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"checkId":"f8385d2699c178ce"}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">cipherData 参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>必选</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>checkId</td><td>是</td><td>string</td><td>人身活体核验ID</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回示例：</div>' +
                                '<pre class="js-box">' +
                                '<code id="code">' + JSON.stringify(
                                    JSON.parse('{"code":0,"msg":"操作成功","data":{"score":"96.69933528689063","certifyState":"SUCCESS","certName":"张 x 新","alivePhoto":"/9j/4AAQSkZJRgABAQAAAQABAAD="}}')
                                    ,  null, 2) +
                                '</code>' +
                                '</pre>' +
                                '<div class="fw mt10 mb10">返回参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>msg</td><td>string</td><td>操作结果说明</td>' +
                                '</tr><tr>' +
                                '<td>code</td><td>int</td><td>错误码（0：操作成功；500：操作失败）</td>' +
                                '</tr><tr>' +
                                '<td>data</td><td>object</td><td>人身活体核验</td>' +
                                '</tr>' +
                                '</table>' +
                                '<div class="fw mt10 mb10">返回data参数说明：</div>' +
                                '<table style="border-collapse: collapse;">' +
                                '<tr style="border-bottom: 1px solid black">' +
                                '<th>参数名</th><th>类型</th><th>说明</th>' +
                                '</tr><tr>' +
                                '<td>score</td><td>Float</td><td>活体检测结果分数 <br /> 业务可根据自己的需求，进行裁定是否合格 <br /> 建议60分以上为合格</td>' +
                                '</tr><tr>' +
                                '<td>certifyState</td><td>string</td><td>人身活体核验状态 <br /> PROCESSING：待核验；SUCCESS：认证通过；FAIL：认证不通过。</td>' +
                                '</tr><tr>' +
                                '<td>certName</td><td>string</td><td>人身活体核验者姓名</td>' +
                                '</tr><tr>' +
                                '<td>alivePhoto</td><td>string</td><td>核验图片（base64编码）</td>' +
                                '</tr>' +
                                '</table>' +
                                ''
                        },
                    ]
                }

            ]

        },
        {
            name: '四、 附录',
            content:
                '<div class="flex mt10 mb10"> ' +
                    '<div class="punctuation"></div> ' +
                    '<span>电子印章类型</span>' +
                '</div>' +
                '<div class="ml10">01：单位专用章</div>' +
                '<div class="ml10">02：财务专用章</div>' +
                '<div class="ml10">03：发票专用章</div>' +
                '<div class="ml10">04：合同专用章</div>' +
                '<div class="ml10">05：法定代表人名章</div>' +
                '<div class="ml10">06: 业务专用章</div>' +
                '<div class="ml10">50：个人签名</div>' +
                '<div class="flex mt10 mb10"> ' +
                '<div class="punctuation"></div><span>NoneStr 随机参数，计算方法：</span></div>' +
                '<div style="height: 392px;width: 969px" class="pic-fl-1" ></div>' +
                '<div class="flex mt10 mb10"> ' +
                '<div class="punctuation"></div><span>国密SM4加密方法：</span></div>' +
                '<div style="height: 220px;width: 932px" class="pic-fl-2" ></div>' +
                '<div class="flex mt10 mb10"> ' +
                '<div class="punctuation"></div><span>AES加密参考：</span></div>' +
                '<div style="height: 220px;width: 932px" class="pic-fl-3" ></div>' +
                '<div class="flex mt10 mb10"> ' +
                '<div class="punctuation"></div><span>X-Gsign-Signature参数签名，计算方法</span></div>' +
                '<div style="height: 220px;width: 932px" class="pic-fl-4" ></div>' +
                ''
        }
    ]
    return document;
}


// <span class="pointer fc-1890FF">详见附录</span>
